module.exports = __webpack_public_path__ + "youtube.4443071eeb7dfc05f2cd9d0e05e8a4db.svg";